
'use strict';

var React = require('react');
var PropTypes = require('prop-types');

module.exports = function render(props) {
    var innerHtml = '<path d="M12.016 10a1 1 0 0 1 1 1l.001 2.771 6.422-5.72-6.423-5.004V6a1 1 0 0 1-1.059.999c-.07-.008-4.566-.21-7.452 2.686-.824.828-1.446 1.836-1.864 3.017C4.729 10.908 7.877 10 12.016 10M1.035 19a1 1 0 0 1-.998-.94c-.251-4.218.78-7.516 3.066-9.801 2.624-2.623 6.165-3.155 7.913-3.248V1A1 1 0 0 1 12.63.211l8.985 7a.999.999 0 0 1 .05 1.536l-8.982 8A1 1 0 0 1 11.018 16l-.002-3.98c-3.449.138-5.97 1.012-7.499 2.603-1.507 1.567-1.482 3.321-1.482 3.338a1 1 0 0 1-.951 1.038l-.05.001"/><!-- Filename: sourceSvg/action/share.svg -->';
    var svgProps = {
        className: props.className ? (props.className + ' uig-svg-icon') : 'uig-svg-icon',
        dangerouslySetInnerHTML: {__html: innerHtml },
        viewBox: '0 0 22 19'
    }
    return React.createElement('svg', Object.assign({}, props, svgProps));
}
    